import { AFTER_LOAD_EVENT } from "./defer-picture";

const ATTRIBUTE = "data-responsive";

function onafterload(e) {
  const { src } = e.detail;
  const target = src.closest(`[${ATTRIBUTE}]`);

  if (target) {
    if ('error' in src.dataset) {
      target.dataset.error = "";
    } else {
      target.style.backgroundImage = `url("${src.currentSrc}")`;
    }
  }
}

function init() {
  window.addEventListener(AFTER_LOAD_EVENT, onafterload);
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./shared/helpers/responsive-bg.js